import React, { useEffect, useState, useRef, useContext } from 'react'
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import socket from '../Components/socket'
import '../css/landing.css'
import Rightcontainer from '../Components/Rightcontainer'
import Downloadbutton from '../Components/Downloadbutton'
import DownloadPopup from '../Components/DownloadPopup'
import io from '../Components/socket'
import Header from '../Components/Header'
import { Token } from '@mui/icons-material'
// import SliderCode from '../Components/SliderCode'
import { LanguageContext } from '../Components/LanguageContext'
import { useTheme } from '../../ThemeContext'

export default function Landing({ userAllData }) {
  const [open, setOpen] = useState(false)
  const [showDownloadPopup, setShowDownloadPopup] = useState(true)
  // const [userAllData, setUserAllData] = useState()

  // language
  const translations = {
    hi: { Tournaments: 'प्रतियोगिता' },
    en: { Tournaments: 'Tournaments' },
  };


  const MyData = localStorage.getItem('meData')
  const meedata = JSON.parse(MyData)
  const { language } = useContext(LanguageContext);

  const addsetting = localStorage.getItem('sitSetting')
  const addCaseSetting = JSON.parse(addsetting)
  // console.log(addCaseSetting);

  // const role = async () => {
  //   const access_token = localStorage.getItem('token')
  //   io.emit('getprofile', access_token)
  //   io.on('setProfile', data => {
  //     // setUserAllData(data)
  //   })
  // }

  useEffect(() => {
    // role()
  }, [])

  // change theme 
  const { theme, toggleTheme } = useTheme();

  const styles = {
    backgroundColor: theme === 'light' ? '#000' : 'black',
    color: theme === 'light' ? 'black' : '#fff',
    // padding: '20px',
    // margin: '20px',
  };

  const styles3 = {
    backgroundColor: theme === 'light' ? '#26355D' : '#27241b',
    color: theme === 'light' ? '#fff' : '#fff',
  };

  const [promptInstall, setPromptInstall] = useState(null);

  const [supportsPWA, setSupportsPWA] = useState(
    localStorage.getItem("supportsPWA") === "true"
  );

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();

      setPromptInstall(e);
      setSupportsPWA(true);

      localStorage.setItem("supportsPWA", "true");

      // globally save event
      window.deferredPrompt = e;
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () =>
      window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const onInstallClick = async () => {

    const prompt =
      promptInstall || window.deferredPrompt;

    if (!prompt) return;

    prompt.prompt();

    const choice = await prompt.userChoice;

    if (choice.outcome === "accepted") {

      localStorage.removeItem("supportsPWA");

      setSupportsPWA(false);

      window.deferredPrompt = null;
    }
  };

  useEffect(() => {

    window.addEventListener("appinstalled", () => {

      localStorage.removeItem("supportsPWA");

      setSupportsPWA(false);

      window.deferredPrompt = null;

    });

  }, []);

  return (
    <>
      {/* {showDownloadPopup && <DownloadPopup onClose={() => setShowDownloadPopup(false)} />} */}
      <div className='leftContainer ' style={{ ...styles, }}>

        <div className="bx-home-scene">

          {/* PREMIUM ANIMATED HOME BACKGROUND */}
          <div className="bx-home-backdrop" aria-hidden="true">
            <div className="bx-home-orb bx-home-orb-one" />
            <div className="bx-home-orb bx-home-orb-two" />
            <div className="bx-home-orb bx-home-orb-three" />

            <div className="bx-home-dot-pattern bx-home-dots-top" />
            <div className="bx-home-dot-pattern bx-home-dots-bottom" />

            <div className="bx-home-light bx-home-light-one" />
            <div className="bx-home-light bx-home-light-two" />

            <div className="bx-home-grid-glow" />
          </div>

          {/* EXISTING PAGE CONTENT */}
          <div className="main-area bx-home-content">



            {(() => {
              const siteMessage = JSON.parse(
                localStorage.getItem("sitSetting") || "{}"
              )?.site_message;

              return siteMessage?.trim() ? (
                <div className="bx-notice-card">
                  <div className="bx-notice-orb bx-notice-orb-one" />
                  <div className="bx-notice-orb bx-notice-orb-two" />

                  <div className="bx-notice-dots bx-notice-dots-left" />
                  <div className="bx-notice-dots bx-notice-dots-right" />

                  <div className="bx-notice-icon-wrap">
                    <span className="bx-notice-icon">📢</span>
                  </div>

                  <div className="bx-notice-content">
                    <span className="bx-notice-label">IMPORTANT NOTICE</span>
                    <h5 className="bx-notice-text">{siteMessage}</h5>
                  </div>

                  <div className="bx-notice-shine" />
                </div>
              ) : null;
            })()}


            {/* <div className="mlk_open_battle_banner">

              <div className="mlk_corner_left"></div>
              <div className="mlk_corner_right"></div>

              <div className="mlk_banner_side">
                ⚔️
              </div>

              <div className="mlk_banner_center">

                <h2>OUR TOURNAMENTS</h2>

                <p>
                  Choose your battle and win big
                </p>

                <div className="mlk_banner_line">
                  <span></span>
                  <i></i>
                  <span></span>
                </div>

              </div>

              <div className="mlk_banner_side">
                ⚔️
              </div>

            </div> */}
            {/* <div className='mlk_open_battle_banner_heading'>
              <img src='../images/our-games.png' className='img-fluid' />
            </div> */}

            {/* OUR TOURNAMENTS BANNER */}



            {/* GAMES */}


            <section className="bx-games-section">
              <div className="bx-games-grid">

                {/* LUDO CLASSIC */}
                <Link
                  className="bx-game-link"
                  to="/Homepage/ludoClassicManual"
                >
                  <div className="bx-game-card bx-ludo-card">

                    <div className="bx-card-glow" />

                    <img
                      src="./mainimage/ludoClassic.png"
                      alt="Ludo Classic"
                      className="bx-game-banner"
                    />

                    {/* Premium LIVE Badge */}
                    <span className="bx-live-badge">
                      <span className="bx-live-indicator" />
                      <span className="bx-live-label">LIVE</span>
                    </span>

                    {/* Animated Dice */}
                    <img
                      src="./mainimage/dice.png"
                      alt="Rolling Dice"
                      className="bx-floating-dice"
                    />

                    <div className="bx-card-shine" />

                  </div>
                </Link>

                {/* WHATSAPP SUPPORT */}
                <a
                  href={
                    JSON.parse(localStorage.getItem("sitSetting"))
                      ?.whatsappSupport || "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bx-game-link"
                >
                  <div className="bx-game-card bx-support-card">

                    <div className="bx-card-glow bx-support-glow" />

                    <img
                      src="./mainimage/wts-support.png"
                      alt="WhatsApp Support"
                      className="bx-game-banner"
                    />

                    <span className="bx-live-badge bx-support-badge">
                      <span className="bx-live-indicator" />
                      <span className="bx-live-label">SUPPORT</span>
                    </span>

                    <div className="bx-card-shine" />

                  </div>
                </a>

              </div>
            </section>



            {/* EXPLORE SERVICES */}

            {/* <div className="mlk_services_banner">

              <span>
                EXPLORE OUR SERVICES
              </span>

            </div> */}

            {/* Services Banner */}
            {/* <div className="services_banner_container ">
              <div
                id="premiumBannerSlider"
                className="carousel slide  premium_banner_slider"
                data-bs-ride="carousel"
                data-bs-interval="3000"
              >
                <div className="carousel-indicators">
                  <button
                    type="button"
                    data-bs-target="#premiumBannerSlider"
                    data-bs-slide-to="0"
                    className="active"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#premiumBannerSlider"
                    data-bs-slide-to="1"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#premiumBannerSlider"
                    data-bs-slide-to="2"
                  ></button>
                </div>

                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img
                      src="./images/first_banner.png"
                      className="d-block w-100"
                      alt="Banner 1"
                    />
                  </div>

                  <div className="carousel-item">
                    <img
                      src="./images/second_banner.png"
                      className="d-block w-100"
                      alt="Banner 2"
                    />
                  </div>

                  <div className="carousel-item">
                    <img
                      src="./images/third_banner.png"
                      className="d-block w-100"
                      alt="Banner 3"
                    />
                  </div>
                </div>

                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#premiumBannerSlider"
                  data-bs-slide="prev"
                >
                  <span className="carousel-control-prev-icon"></span>
                </button>

                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#premiumBannerSlider"
                  data-bs-slide="next"
                >
                  <span className="carousel-control-next-icon"></span>
                </button>
              </div>
            </div> */}

            {/* <div className="quick_action_wrapper">

              {supportsPWA && (
                <div
                  className="quick_action_card"
                  onClick={onInstallClick}
                >
                  <div className="quick_action_icon">
                    📲
                  </div>

                  <div className="quick_action_text">
                    <h4>Install App</h4>
                    <span>Fast access</span>
                  </div>
                </div>
              )}

              <div
                className="quick_action_card"
                onClick={toggleTheme}
              >
                <div className="quick_action_icon">
                  {theme === "light" ? "🌙" : "☀️"}
                </div>

                <div className="quick_action_text">
                  <h4>
                    {theme === "light"
                      ? "Dark Mode"
                      : "Light Mode"}
                  </h4>

                  <span>Change Theme</span>
                </div>
              </div>

            </div> */}

            {/* PREMIUM FLOATING INSTALL BUTTON */}
            {supportsPWA && (
              <button
                type="button"
                className="bx-install-float"
                onClick={onInstallClick}
                aria-label="Install Box Ludo App"
              >
                <span className="bx-install-icon-wrap">
                  <svg
                    className="bx-install-svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M12 3V15M7 10L12 15L17 10"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5 16V19C5 19.55 5.45 20 6 20H18C18.55 20 19 19.55 19 19V16"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>

                <span className="bx-install-content">
                  <span className="bx-install-title">Install App</span>
                  <span className="bx-install-subtitle">Play instantly</span>
                </span>

                <span className="bx-install-arrow">
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="M9 18L15 12L9 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>

                <span className="bx-install-shimmer" />
              </button>
            )}

            <div className='downloadButton'>
              <Downloadbutton />
            </div>
          </div>
        </div>
      </div>
      <div className="support_samll_card_btn_type whatsap_btn">
        {JSON.parse(localStorage.getItem("sitSetting")) ==
          "undefined" ? (
          ""
        ) : JSON.parse(localStorage.getItem("sitSetting"))
          ?.whatsappSupport ? (
          <>
            <a
              href={
                JSON.parse(localStorage.getItem("sitSetting")) ==
                  "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                    ?.whatsappSupport
              }
              target="_blank"
            >
              {/* <img
                width="40px"
                src={process.env.PUBLIC_URL + "/images/whatsapp.png"}
                alt=""
              /> */}
            </a>
          </>
        ) : (
          ""
        )}
      </div>
      <div className="support_samll_card_btn_type whatsap_btn" style={{ marginBottom: "65px" }}>
        {JSON.parse(localStorage.getItem("sitSetting")) ==
          "undefined" ? (
          ""
        ) : JSON.parse(localStorage.getItem("sitSetting"))
          ?.CompanyMobile ? (
          <>
            {/* <a
              href={
                `tel:${JSON.parse(localStorage.getItem("sitSetting")) ==
                  "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                    ?.CompanyMobile}`
              }
              target="_blank"
            >
              <img
                width="40px"
                src={process.env.PUBLIC_URL + "/images/phone.png"}
                alt=""
              />
            </a> */}
          </>
        ) : (
          ""
        )}

      </div>

      <div className='rightContainer'>
        <Rightcontainer />
      </div>
      {/* WHATSAPP CHANNEL FLOATING BUTTON */}
      {/* <a
        href="https://whatsapp.com/channel/0029Vb7csxR4Crfed8O6Qy2t"
        target="_blank"
        rel="noreferrer"
        className="join-channel-btn"
      >
        🎁 Join Now
      </a> */}

    </>
  )
}
